<div dropdown [isDisabled]="1 | isReadonlyRole" class="btn-group">
  <button
    dropdownToggle
    type="button"
    class="btn btn-secondary-warning dropdown-toggle"
    matTooltip="You can perform multiple actions using this button."
    i18n-matTooltip
  >
    <span class="cs-icon cs-icon-bolt"></span> <ng-container i18n>Actions</ng-container>
  </button>
  <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
    <li matTooltip="Pause selected automations." i18n-matTooltip matTooltipPosition="left">
      <button (click)="table?.onPauseSelected()" [disabled]="!isAnySelected" type="button">
        <i class="fal fa-pause fa-fw"></i><ng-container i18n>Pause</ng-container>
      </button>
    </li>
    <li matTooltip="Resume selected automations." i18n-matTooltip matTooltipPosition="left">
      <button (click)="table?.onResumeSelected()" [disabled]="!isAnySelected" type="button">
        <i class="fal fa-play fa-fw"></i><ng-container i18n>Resume</ng-container>
      </button>
    </li>
    <li matTooltip="Archive selected automations." i18n-matTooltip matTooltipPosition="left">
      <button (click)="table?.onArchiveSelected()" type="button" [disabled]="!isAnySelected">
        <i class="far fa-fw fa-archive"></i> <ng-container i18n>Archive</ng-container>
      </button>
    </li>
    <li matTooltip="Unarchive selected automations." i18n-matTooltip matTooltipPosition="left">
      <button (click)="table?.onUnarchiveSelected()" type="button" [disabled]="!isAnySelected">
        <i class="far fa-fw fa-archive"></i> <ng-container i18n>Unarchive</ng-container>
      </button>
    </li>

    <li matTooltip="Delete selected automations." i18n-matTooltip matTooltipPosition="left">
      <button (click)="table?.onDeleteSelected()" [disabled]="!isAnySelected" type="button">
        <i class="cs-icon cs-icon-trash"></i> <ng-container i18n>Delete</ng-container>
      </button>
    </li>
  </ul>
</div>
